import React, { useEffect, memo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

//------modules-------//
import FormularioNewsletter from "../modules/FormularioNewsletter";
import ResumenInformacionEmpresa from "../modules/ResumenInformacionEmpresa";
import MapaUbicaciones from "../modules/MapaUbicaciones";

const Footer = () => {
  const { empresaData } = useSelector((state) => state.empresa);
  const componentes = useSelector(
    (state) =>
      state.empresa &&
      state.empresa.empresaData &&
      state.empresa.empresaData.componentes
  );

  useEffect(() => {
    //dispatch(getEmpresa());
  }, []);

  return (
    <ContainerFooter>
      <FooterWrapper>
        {empresaData &&
          empresaData.redes_sociales &&
          empresaData.redes_sociales.length > 0 && (
            <ListaRedesSociales>
              <ul>
                {empresaData &&
                  empresaData.redes_sociales &&
                  empresaData.redes_sociales.length > 0 &&
                  empresaData.redes_sociales.map((redes, index) => (
                    <li key={index}>
                      <a href={redes.url} target="_blank">
                        <img src={redes.logo_url} alt={redes.nombre} />
                      </a>
                    </li>
                  ))}
              </ul>
            </ListaRedesSociales>
          )}

        <FooterInformacion>
          {componentes && componentes.FOOTER_SUSCRIPCION_NEWSLATTER && (
            <FormularioNewsletter empresa={empresaData} />
          )}
          <ResumenInformacionEmpresa empresa={empresaData} />
          {componentes && componentes.FOOTER_MAPA_SUCURSALES && (
            <MapaUbicaciones empresa={empresaData} />
          )}
        </FooterInformacion>
      </FooterWrapper>
    </ContainerFooter>
  );
};
const ContainerFooter = styled.footer`
  background-color: ${(props) => props.theme.footerBgColor};
  padding: 50px 20px 100px 20px;
  margin-top: 10px;
  /* border-top: 1px solid #f5f5f5; */
  @media only screen and (max-width: 720px) {
    display: none;
  }
`;

const FooterWrapper = styled.section`
  display: ${(props) => props.theme.footerDisplay};
  max-width: 1440px;
  margin: auto;
  flex-direction: ${(props) => props.theme.footerFlexDirection};
  align-items: flex-start;
  justify-content: space-between;
`;

const ListaRedesSociales = styled.section`
  order: ${(props) => props.theme.footerOrderRedesSociales};
  text-align: center;
  list-style-type: none;
  > ul {
    > li {
      display: inline-block;
      padding: 5px;
    }
  }
`;

const FooterInformacion = styled.section`
  order: ${(props) => props.theme.footerOrderRedesInfoEmpresa};
  display: flex;
  justify-content: ${(props) => props.theme.footerInformationJustifyContent};
  align-items: flex-start;
  text-align: ${(props) => props.theme.footerInformationTextAlign};
  > article {
    width: ${(props) => props.theme.footerColumnWidth};
    margin: ${(props) => props.theme.footerColumnMargin};
    @media only screen and (max-width: 720px) {
      width: 98%;
      &:first-child {
        display: none;
      }
      &:last-child {
        display: none;
      }
    }
  }
`;

export default memo(Footer);
